import { Grid, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useLayoutContext } from '../../Context/Layout.context';
import { useStyles } from './ExamineeDetails.styles';
import { SelectableTableColumn } from '../SelectableTable/SelectableTable.types';
import { SelectableTable } from '../SelectableTable/SelectableTable.component';
import { ExamineeSessionDetailsDto, SessionDetailsResponse, SessionDetailsTableItem } from './ExamineeDetails.types';
import { getStatus } from '../../pages/Assessment/Helpers/Status.component';
import { getProcessLabel } from '../../utils/assessmentSessionProcess';
import ProcessesIcon from '../ProcessesList/ProcessIcon.component';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import { AxiosResponse } from 'axios';
import { getExamineeSessionDetails } from '../../services/scoring/scoring.service';
import { setValueIfNullString } from './ExamineeInfo.component';
import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';
import { SolutionCardModal } from '../../pages/SolutionCard/SolutionCardModal.component';

interface IExamineeDetailsSessionInfo {
  taskSolutionSheetId: string;
}

export const ExamineeDetailsSessionInfo: React.FC<IExamineeDetailsSessionInfo> = ({ taskSolutionSheetId }) => {
  const classes = useStyles();

  const { showLoader } = useLayoutContext();
  const [dataFromServer, setDataFromServer] = useState<ExamineeSessionDetailsDto[]>([]);
  const [data, setData] = useState<SessionDetailsTableItem[]>([]);
  const [noSessionScreen, setNoSessionScreen] = useState<boolean>(false);
  const [solutionCardModalOpen, setSolutionCardModalOpen] = useState<boolean>(false);

  useEffect(() => {
    showLoader(true);
    getExamineeSessionDetails(taskSolutionSheetId)
      .then((res: AxiosResponse<SessionDetailsResponse>) => {
        setDataFromServer(res.data.sessionDetails);
        if (res.data.sessionDetails.length === 0) {
          setNoSessionScreen(true);
        }
      })
      .catch((e) => {
        console.error(e);
        setNoSessionScreen(true);
      })
      .finally(() => showLoader(false));
  }, []);

  useEffect(() => {
    const tableData: SessionDetailsTableItem[] = dataFromServer.map((row) => ({
      name: setValueIfNullString(row.examTaskGroupName),
      rgzId: setValueIfNullString(row.examTaskGroupSolutionScoreId),
      process:
        row.processTypeId !== null && row.processTypeId !== AssessmentSessionProcessTypeId.Scoring ? (
          <ProcessesIcon
            letter={getProcessLabel(row.processTypeId).letter}
            tooltip={getProcessLabel(row.processTypeId).label}
          />
        ) : (
          <> - </>
        ),
      status: row.stateId !== null ? getStatus(row.stateId) : <> - </>,
      examiner: row.firstName !== '' || row.lastName !== '' ? `${row.firstName} ${row.lastName}` : '-',
      examinerNumber: setValueIfNullString(row.examinerNumber),
    }));
    setData(tableData);
  }, [dataFromServer]);

  const columns: SelectableTableColumn[] = [
    {
      id: 'name',
      type: 'text',
      title: 'Nazwa GZ',
      filterType: null,
    },
    {
      id: 'rgzId',
      type: 'text',
      title: 'ID RGZ',
      filterType: null,
    },
    {
      id: 'process',
      type: 'text',
      title: 'Proces',
      filterType: null,
      skipEnterMethod: true,
    },
    {
      id: 'status',
      type: 'text',
      title: 'Status',
      filterType: null,
      skipEnterMethod: true,
    },
    {
      id: 'examiner',
      type: 'text',
      title: 'Egzaminator',
      filterType: null,
      skipEnterMethod: true,
    },
    {
      id: 'examinerNumber',
      type: 'text',
      title: 'Nr egzaminatora',
      filterType: null,
      skipEnterMethod: true,
    },
  ];

  const cardId = taskSolutionSheetId;
  return (
    <>
      <Grid item xs={12} style={{ justifyContent: 'center' }}>
        <Typography className={classes.tabTitle}>Informacje o sesjach oceniania</Typography>

        {dataFromServer.length > 0 && (
          <div>
            <Typography
              className={classes.tabTitle}
              style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)', marginBottom: '30px', paddingBottom: '10px' }}
            >
              ID karty{' '}
              <button onClick={() => setSolutionCardModalOpen(true)} className={classes.buttonLink}>
                {cardId}
              </button>
            </Typography>
            <SelectableTable<SessionDetailsTableItem>
              columns={columns}
              rows={data}
              caption={'Informacje o sesjach oceniania'}
            />
          </div>
        )}
        {noSessionScreen && (
          <div style={{ margin: '0 auto', marginTop: '150px', textAlign: 'center', width: '500px' }}>
            <PhotoLibraryOutlinedIcon
              style={{ fontSize: '80px', color: 'rgba(202, 202, 252, 0.3', margin: '0 auto' }}
            />
            <Typography style={{ fontSize: '1em', color: 'rgb(60, 65, 154)', fontWeight: 700 }}>
              Brak informacji o sesjach ocenienia, ponieważ karta zdającego nie została jeszcze przetworzona
            </Typography>
          </div>
        )}
        {solutionCardModalOpen && <SolutionCardModal cardId={cardId} onClose={() => setSolutionCardModalOpen(false)} />}
      </Grid>
    </>
  );
};
